<template>
  <svg
    width="50"
    height="50"
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" y="0.5" width="49" height="49" rx="24.5" fill="#FFF5F1" />
    <rect x="0.5" y="0.5" width="49" height="49" rx="24.5" stroke="#FF6347" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M33.0604 27.9394C33.451 28.3299 33.451 28.9631 33.0604 29.3536C32.6699 29.7441 32.0368 29.7441 31.6462 29.3536L25.7676 23.4749C25.3771 23.0844 24.7439 23.0844 24.3534 23.4749L18.4747 29.3536C18.0842 29.7441 17.451 29.7441 17.0605 29.3536C16.67 28.9631 16.67 28.3299 17.0605 27.9394L24.3534 20.6465C24.7439 20.2559 25.3771 20.2559 25.7676 20.6465L33.0604 27.9394Z"
      fill="#153D49"
    />
  </svg>
</template>
